<script lang="ts">
    import { apiBaseURL } from "../../../config"
    import { fly } from "svelte/transition"
    export let subPointId
    export let person
    export let i
</script>

<div class="person-card" in:fly="{{ y: 80, opacity: 0, duration: 750, delay: 100 + 200 * i }}">
    <div class="profile-img-container">
        <img src="{`${apiBaseURL}subpoint/${subPointId}/${person.image?.src}`}" alt="img" />
    </div>
    <div class="description">
        <div class="name">{person.Name}</div>
        <div class="desc">{person.shortDescription}</div>
        <button class="vita"
            ><span><img src="/media/arrow-right-thin.svg" alt="arrow" /></span> <span>Vita</span></button
        >
    </div>
</div>

<style lang="less">
    @import "../../assets/css/variables.less";
    .person-card {
        display: flex;
        height: 200px;
        width: 350px;
        margin-top: 10px !important;

        @media @mobile {
            transform-origin: left;
            margin: 0px 40px 40px 0px;
            transform: scale(0.8);
        }
        @media @tablet {
            margin: 0px 40px 40px 20px;
            transform: scale(1);
        }

        gap: 20px;
        &:hover {
            box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.281);
        }
        .profile-img-container {
            flex-shrink: 0;
            width: 140px;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .description {
            display: flex;
            flex-direction: column;
            gap: 6px;
            .name {
                text-align: start;
                font-weight: bold;
            }
            .desc {
                text-align: start;
            }
            .vita {
                height: 34px;
                gap: 5px;
                display: flex;
                align-items: center;
                span {
                    height: fit-content;
                }
            }
        }
    }
</style>
